import { render, staticRenderFns } from "./limitesMensajes.vue?vue&type=template&id=04548de6&scoped=true"
import script from "./limitesMensajes.vue?vue&type=script&lang=js"
export * from "./limitesMensajes.vue?vue&type=script&lang=js"
import style0 from "./limitesMensajes.vue?vue&type=style&index=0&id=04548de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04548de6",
  null
  
)

export default component.exports